import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { selectedGeocodeLocation } from '@/common/atoms/community';
import { DEFAULT_LOCALE_IDS } from '../../constants';
import type { MatchableAddress } from '../../types';
import { matches } from '../../utils/location';
import { useIsVectorMap } from '../useIsVectorMap';

interface Props {
  active: boolean;
  selected: boolean;
  address: MatchableAddress;
}

export function usePinClass({ active, selected, address }: Props) {
  const selectedLocation = useAtomValue(selectedGeocodeLocation);
  const isVectorMap = useIsVectorMap();

  return useMemo(() => {
    const classNames = ['pin'];

    if (active) {
      classNames.push('active');
    }

    if (selected) {
      classNames.push('selected');
    }

    const isDefaultSearch =
      selectedLocation && DEFAULT_LOCALE_IDS.includes(selectedLocation.id);

    if (
      isVectorMap &&
      !isDefaultSearch &&
      !matches(selectedLocation, address)
    ) {
      classNames.push('outOfBounds');
    }

    return classNames.join(' ');
  }, [active, selected, selectedLocation, isVectorMap, address]);
}
